import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

interface GoToPaymentPageProps {
  cartId: string;
  topicContext?: {
    topicId: number;
    whitelabelURL: string;
  };
  captchaResponse?: string;
}

export const goToPaymentPage = ({
  cartId,
  topicContext,
  captchaResponse,
}: GoToPaymentPageProps) => {
  const query = captchaResponse
    ? { captcha_response: captchaResponse }
    : undefined;

  const url = topicContext?.topicId
    ? dynamicTopicResourcePath(
        Routes.topic_topic_payment_page_path(
          topicContext.topicId,
          cartId,
          query,
        ),
        topicContext,
      )
    : Routes.payment_page_path(cartId, query);

  window.location.href = url;
};
